import i18n from "@swa-ui/locale";

import {
  ERRORED,
  SERVICE_UNAVAILABLE,
  UNAVAILABLE,
} from "../../defines/usernameAvailabilityStatus";
import { getUsernameFormFieldSchema } from "../UsernameFormField";

export const getNewUsernameFormFieldSchema = () =>
  getUsernameFormFieldSchema()
    .test(
      "username-unavailable",
      i18n(`NewUsernameFormField__TEXT_USERNAME_UNAVAILABLE`),
      (value, testContext) => testContext.options.context.usernameAvailabilityStatus !== UNAVAILABLE
    )
    .test(
      "username-errored",
      i18n(`NewUsernameFormField__TEXT_USERNAME_ERRORED`),
      (value, testContext) => testContext.options.context.usernameAvailabilityStatus !== ERRORED
    )
    .test(
      "username-service-unavailable",
      i18n(`NewUsernameFormField__TEXT_USERNAME_SERVICE_UNAVAILABLE`),
      (value, testContext) =>
        testContext.options.context.usernameAvailabilityStatus !== SERVICE_UNAVAILABLE
    );
